module.exports = {"meta":"Reden & Ansprachen","persons":{"title":"Reden & Ansprachen: Personen","burialSpeaker":"Ansprache/Begrüssung Bestattung","ceremonySpeaker":"Geleitworte Bestattung","placeholder":"Nachname, Vorname","saveButton":"Speichern"},"documents":{"title":"Dokumente","obituaryText":"Text Todesanzeige","funeralSpeechText":"Text Rede Bestattung","partySpeechText":"Text Rede Feier","uploadButton":"PDF-Upload","downloadButton":"Runterladen","deleteButton":"Löschen","filenameLabel":"Dateiname"},"allInfo":{"title":"Reden & Ansprachen: Dokumente"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/speeches.json
// module id = TpUV
// module chunks = 1